export default "__VITE_ASSET__439009cb__"